/**
 * Live sends never fall through to the scripted preview engine.
 * Prompts for connected ERP domains (inventory, sales, procurement, finance,
 * projects, sakhtar composite) are quoted against the real contract.
 * Unsupported sends or interactive drills stay on the production screen
 * and notify that they are not connected.
 */
import type { ScopeKey } from './types.ts';

export const LIVE_DOMAIN_UNAVAILABLE =
  'این حوزه هنوز برای دستیار متصل نشده است و پاسخی از دادهٔ نمونه ساخته نمی‌شود.';

export const LIVE_SUPPORTED_DOMAINS = [
  'inventory',
  'sales',
  'procurement',
  'finance',
  'projects',
  'sakhtar',
] as const;

export type LiveSendRoute = 'preview' | 'inventory' | 'live' | 'unavailable';

export function liveSendRoute(input: {
  readonly live: boolean;
  readonly requestType: 'prompt' | 'drill';
  readonly selected: readonly ScopeKey[];
}): LiveSendRoute {
  if (!input.live) return 'preview';
  if (input.requestType === 'drill') return 'unavailable';
  // No module selection is required for a central general-knowledge question.
  if (input.requestType === 'prompt' && input.selected.length === 0) return 'live';
  if (input.requestType === 'prompt' && input.selected.length > 0) {
    if (input.selected.includes('inventory')) return 'inventory';
    if (input.selected.some((s) => (LIVE_SUPPORTED_DOMAINS as readonly string[]).includes(s))) {
      return 'live';
    }
  }
  return 'unavailable';
}
